
gsap.to(".custom-anim .char", {
  opacity: 0,
  yPercent: 130,
  stagger: 0.06,
  ease: "back.out",
  scrollTrigger: {
    trigger: ".custom-anim",
    start: "top center",
    end: "bottom center",
    scrub: true,
    onEnter: () => {
     alert("true");
    },
    onLeave: () => {
        alert("true new");
    },
  },
});

// document.addEventListener('DOMContentLoaded', function () {
//   // Your GSAP and ScrollTrigger code here
//   const text = new SplitType('.custom-anim');
//   gsap.registerPlugin(ScrollTrigger);
//   gsap.to('.char', {
//     y: 0,
//     stagger: 0.08,
//     delay: 0.5,
//     duration: 0.2,
//     scrollTrigger: {
//       trigger: '.char',
//       start: '20px 80%',
//       toggleActions: 'restart none none none',
//     },
//   });
// });




// // For more information, see greensock.com/docs/v3/Plugins/ScrollTrigger
// gsap.registerPlugin(ScrollTrigger);

// // You can use a ScrollTrigger in a tween or timeline
// gsap.to(".char", {
//   x: 400,
//   rotation: 360,
//   scrollTrigger: {
//     trigger: ".b",
//     start: "top center",
//     end: "top 100px",
//     scrub: true,
//     markers: true,
//     id: "scrub"
//   }
// });


// // Or you can attach a tween or timeline to a ScrollTrigger later
// const anim = gsap.to(".c", {
//   x: 400,
//   rotation: 360,
//   duration: 3
// });

// ScrollTrigger.create({
//   trigger: ".c",
//   animation: anim,
//   // Uncomment these to see how they affect the ScrollTrigger
//   // markers: true,
//   // start: "top center",
//   // end: "top 100px",
//   // toggleClass: "active",
//   // pin: true,
//   // scrub: 1,
//   // onUpdate: self => {
//   //   console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
//   // }
// });





// gsap.registerPlugin(ScrollTrigger);

// // You can use a ScrollTrigger in a tween or timeline
// gsap.to(".custom-anim", {
//        y: 0,
//         stagger: 0.08, // Adjust the stagger value to control the delay between each character
//         delay: 0.5,
//         duration: 1.5,
//   scrollTrigger: {
//     trigger: ".custom-anim",
//     start: "top center",
//     end: "top 100px",
//     scrub: true,
//     id: "scrub"
//   }
// });


// // Or you can attach a tween or timeline to a ScrollTrigger later
// const anim = gsap.to(".c", {
//   x: 400,
//   rotation: 360,
//   duration: 3
// });

// ScrollTrigger.create({
//   trigger: ".c",
//   animation: anim,
//   // Uncomment these to see how they affect the ScrollTrigger
//   // markers: true,
//   // start: "top center",
//   // end: "top 100px",
//   // toggleClass: "active",
//   // pin: true,
//   // scrub: 1,
//   // onUpdate: self => {
//   //   console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
//   // }
// });
